import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';
import { HistoryRouter } from 'redux-first-history/rr6';
import { ToastContainer } from 'react-toastify';

import createTheme from '@mui/material/styles/createTheme';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { generateTheme } from './styles/muiTheme';
import _package from '../package.json';
import AppRoutes from './routes';
import { history, store } from './store/createStore';
import ErrorBoundary from './components/ErrorBoundary';

import './styles/index.css';

console.log('_package.version: ', _package.version);

function App() {
  const theme = React.useMemo(() => {
    return createTheme(generateTheme('light'));
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ErrorBoundary>
          <HelmetProvider>
            <Helmet>
              <title>Orchestrate Admin</title>
              <meta
                name='viewport'
                content='width=device-width, initial-scale=1'
              />
            </Helmet>
            <ToastContainer
              position='bottom-right'
              autoClose={10000}
              theme='colored'
            />
            <AppRoutes />
          </HelmetProvider>
        </ErrorBoundary>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

function AppContainer() {
  return (
    <React.StrictMode>
      <ReduxProvider store={store}>
        <HistoryRouter history={history}>
          <App />
        </HistoryRouter>
      </ReduxProvider>
    </React.StrictMode>
  );
}

export default AppContainer;
